import { __extends, __assign } from 'tslib';
import React__default from 'react';
import 'react-dates/initialize';
import moment from 'moment-timezone';
import DateRangeFilterController from '../DateRangeFilterController/DateRangeFilterController.component.js';
import DateRangeFilterSidebar from '../DateRangeFilterSidebar/DateRangeFilterSidebar.component.js';
import { propTypes, defaultProps } from './DateRangeFilter.types.js';
import styles from './DateRangeFilter.module.scss.js';

var DateRangeFilter = /** @class */ (function (_super) {
    __extends(DateRangeFilter, _super);
    function DateRangeFilter(props) {
        var _this = _super.call(this, props) || this;
        _this.openSidebarStartDate = function () {
            var newState = {
                sidebarIsOpen: true,
            };
            _this.setState(newState, function () {
                if (_this.startDateInputRef.current) {
                    _this.startDateInputRef.current.focus({
                        preventScroll: true,
                    });
                }
            });
        };
        _this.openSidebarEndDate = function () {
            var newState = {
                sidebarIsOpen: true,
            };
            _this.setState(newState, function () {
                if (_this.endDateInputRef.current) {
                    _this.endDateInputRef.current.focus({
                        preventScroll: true,
                    });
                }
            });
        };
        _this.closeSidebar = function () {
            _this.setState({ sidebarIsOpen: false });
        };
        _this.previousInterval = function () {
            var _a = _this.props, startDate = _a.startDate, endDate = _a.endDate, onDatesChange = _a.onDatesChange, timeZone = _a.timeZone;
            var interval = endDate.diff(startDate, 'days') + 1;
            var newStartDate = moment(startDate)
                .tz(timeZone)
                .subtract(interval, 'day');
            var newEndDate = moment(endDate)
                .tz(timeZone)
                .subtract(interval, 'day');
            onDatesChange({
                startDate: newStartDate,
                endDate: newEndDate,
                selectedRange: 'custom',
            });
        };
        _this.shouldDisablePrevIntervalButton = function () {
            var _a = _this.props, isDayBlocked = _a.isDayBlocked, disabled = _a.disabled, startDate = _a.startDate, endDate = _a.endDate, timeZone = _a.timeZone;
            if (disabled) {
                return true;
            }
            if (!isDayBlocked) {
                return false;
            }
            var interval = endDate.diff(startDate, 'days') + 1;
            var newEndDate = moment(endDate)
                .tz(timeZone)
                .subtract(interval, 'day');
            return isDayBlocked(startDate) || isDayBlocked(newEndDate);
        };
        _this.nextInterval = function () {
            var _a = _this.props, startDate = _a.startDate, endDate = _a.endDate, onDatesChange = _a.onDatesChange, timeZone = _a.timeZone;
            var interval = endDate.diff(startDate, 'days') + 1;
            var newStartDate = moment(startDate)
                .tz(timeZone)
                .add(interval, 'day');
            var newEndDate = moment(endDate).tz(timeZone).add(interval, 'day');
            onDatesChange({
                startDate: newStartDate,
                endDate: newEndDate,
                selectedRange: 'custom',
            });
        };
        _this.shouldDisableNextIntervalButton = function () {
            var _a = _this.props, isDayBlocked = _a.isDayBlocked, disabled = _a.disabled, startDate = _a.startDate, endDate = _a.endDate, timeZone = _a.timeZone;
            if (disabled) {
                return true;
            }
            if (!isDayBlocked) {
                return false;
            }
            var interval = endDate.diff(startDate, 'days') + 1;
            var newStartDate = moment(startDate)
                .tz(timeZone)
                .add(interval, 'day');
            return isDayBlocked(newStartDate) || isDayBlocked(endDate);
        };
        _this.getMobileDateRangeStringFromSelectedRange = function () {
            var _a = _this.props, startDate = _a.startDate, endDate = _a.endDate, dateFormat = _a.dateFormat, dateSeparator = _a.dateSeparator, selectedRange = _a.selectedRange, rangeLabels = _a.rangeLabels;
            var formattedStartDate = startDate.format(dateFormat);
            var formattedEndDate = endDate.format(dateFormat);
            if (selectedRange === 'custom') {
                return "".concat(formattedStartDate, " ").concat(dateSeparator, " ").concat(formattedEndDate);
            }
            if (selectedRange) {
                return rangeLabels[selectedRange];
            }
            return '';
        };
        _this.state = {
            sidebarIsOpen: false,
        };
        // Maintain a ref to inputs such that we can
        // focus them when clicking the controller buttons
        _this.startDateInputRef = React__default.createRef();
        _this.endDateInputRef = React__default.createRef();
        return _this;
    }
    DateRangeFilter.prototype.render = function () {
        var sidebarIsOpen = this.state.sidebarIsOpen;
        var _a = this.props, 
        // Props controlled by this component
        startDate = _a.startDate, endDate = _a.endDate, disabled = _a.disabled, 
        // Props from Sidebar
        selectedRange = _a.selectedRange, customSelectedRange = _a.customSelectedRange, customDateRanges = _a.customDateRanges, isCustomRangeShowed = _a.isCustomRangeShowed, isDayBlocked = _a.isDayBlocked, calendarLocale = _a.calendarLocale, rangeLabels = _a.rangeLabels, dateLabels = _a.dateLabels, sidebarHeader = _a.sidebarHeader, applyFiltersText = _a.applyFiltersText, dateFormat = _a.dateFormat, inputDateFormats = _a.inputDateFormats, calendarProps = _a.calendarProps, sidebarZIndex = _a.sidebarZIndex, invalidInputErrorMessage = _a.invalidInputErrorMessage, onDatesChange = _a.onDatesChange, sidebarProps = _a.sidebarProps, timeZone = _a.timeZone, 
        // Props from controller
        dateSeparator = _a.dateSeparator, hideIntervalShortcuts = _a.hideIntervalShortcuts, dateRangeFilterDesktopClassName = _a.dateRangeFilterDesktopClassName, dateRangeFilterMobileClassName = _a.dateRangeFilterMobileClassName, rowButtonProps = _a.rowButtonProps, mobileControllerTitle = _a.mobileControllerTitle;
        return (React__default.createElement("div", { "data-testid": this.props['data-testid'], className: styles.DateRangeFilter },
            React__default.createElement(DateRangeFilterController, { startDate: startDate, endDate: endDate, selectedRangeText: this.getMobileDateRangeStringFromSelectedRange(), dateFormat: dateFormat, dateSeparator: dateSeparator, mobileControllerTitle: mobileControllerTitle, onStartDateButtonClick: this.openSidebarStartDate, onEndDateButtonClick: this.openSidebarEndDate, onMobileRowButtonClick: this.openSidebarStartDate, onNextIntervalClick: this.nextInterval, onPrevIntervalClick: this.previousInterval, disableNextIntervalButton: this.shouldDisableNextIntervalButton(), disablePrevIntervalButton: this.shouldDisablePrevIntervalButton(), disabled: disabled, hideIntervalShortcuts: hideIntervalShortcuts, desktopClassName: dateRangeFilterDesktopClassName, mobileClassName: dateRangeFilterMobileClassName, rowButtonProps: rowButtonProps }),
            React__default.createElement(DateRangeFilterSidebar, { isOpen: sidebarIsOpen, customDateRanges: customDateRanges, customSelectedRange: customSelectedRange, onClose: this.closeSidebar, startDateInputRef: this.startDateInputRef, endDateInputRef: this.endDateInputRef, startDate: startDate, endDate: endDate, isCustomRangeShowed: isCustomRangeShowed, selectedRange: selectedRange, isDayBlocked: isDayBlocked, onDatesChange: onDatesChange, calendarLocale: calendarLocale, rangeLabels: rangeLabels, dateLabels: dateLabels, sidebarHeader: sidebarHeader, applyFiltersText: applyFiltersText, dateFormat: dateFormat, inputDateFormats: inputDateFormats, calendarProps: calendarProps, sidebarZIndex: sidebarZIndex, invalidInputErrorMessage: invalidInputErrorMessage, sidebarProps: sidebarProps, timeZone: timeZone })));
    };
    DateRangeFilter.displayName = 'DateRangeFilter';
    DateRangeFilter.propTypes = propTypes;
    DateRangeFilter.defaultProps = __assign({}, defaultProps);
    return DateRangeFilter;
}(React__default.Component));

export { DateRangeFilter as default };
